import React from 'react'

function ScrapperTabs({ handleBodyActive, activeBody }) {

    const handleTabClick = (selectedTab) => {
        handleBodyActive(selectedTab);
    };

  return (
    <div className="Content__scraperForm--tabs">
        <div className={`Content__scraperForm--tabs-tab ${activeBody === "scrapper" ? "activeTab" : ""}`} tab="scraper" onClick={() => handleTabClick("scrapper")}>
            <i className="fa-solid fa-clone"></i>
            <span>Scrapear</span>
        </div>
        <div className={`Content__scraperForm--tabs-tab ${activeBody === "exportarCSV" ? "activeTab" : ""}`} onClick={() => handleTabClick("exportarCSV")} tab="exportarCSV">
            <i className="fa-solid fa-file-export"></i>
            <span>Exportar CSV</span>
        </div>
    </div>
  )
}

export { ScrapperTabs }